import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./App.css";

import TopContactBar from "./components/TopContactBar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import BookingPopup from "./components/BookingPopup";

import Home from "./pages/Home";
import About from "./pages/About";
import CorporateTraining from "./pages/CorporateTraining";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import TheSatimaWay from "./pages/TheSatimaWay";

// Service Pages
import WebDesignKenya from "./pages/WebDesignKenya";
import DigitalMarketingSMEs from "./pages/DigitalMarketingSMEs";
import SocialMediaManagement from "./pages/SocialMediaManagement";
import ContentCreation from "./pages/ContentCreation";
import SEO from "./pages/SEO";
import DigitalStrategyConsultation from "./pages/DigitalStrategyConsultation";
import CustomSoftwareSolutions from "./pages/CustomSoftwareSolutions";


// =====================================
// META PIXEL TRACKING HOOK
// =====================================

function usePageTracking() {

  const location = useLocation();

  useEffect(() => {

    if (window.fbq) {

      window.fbq("track", "PageView");

    }

  }, [location]);

}


// =====================================
// MAIN APP
// =====================================

function App() {

  return (

    <Router>

      <ScrollToTop />

      <Layout />


      {/* BOOKING POPUP */}

      <BookingPopup />


      {/* FLOATING WHATSAPP BUTTON */}

      <a
        href="https://wa.me/254775137928?text=Hello%2C%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        className="dn-whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >

        <i className="fab fa-whatsapp"></i>

      </a>

    </Router>

  );

}


// =====================================
// LAYOUT COMPONENT
// =====================================

const Layout = () => {

  const location = useLocation();


  // Track every route/page change

  usePageTracking();


  // Check if current page is Contact

  const isContactPage =
    location.pathname.startsWith("/contact");


  return (

    <>

      <TopContactBar />

      <Navbar />


      {/* =====================================
          WEBSITE ROUTES
      ===================================== */}

      <Routes>


        <Route
          path="/"
          element={<Home />}
        />


        <Route
          path="/about"
          element={<About />}
        />


        <Route
          path="/corporate-training"
          element={<CorporateTraining />}
        />


        <Route
          path="/contact"
          element={<Contact />}
        />


        <Route
          path="/the-satima-way"
          element={<TheSatimaWay />}
        />


        {/* =====================================
            SERVICE ROUTES
        ===================================== */}


        <Route
          path="/web-design-kenya"
          element={<WebDesignKenya />}
        />


        <Route
          path="/digital-marketing-smes"
          element={<DigitalMarketingSMEs />}
        />


        <Route
          path="/social-media-management-services"
          element={<SocialMediaManagement />}
        />


        <Route
          path="/content-creation-services"
          element={<ContentCreation />}
        />


        <Route
          path="/seo-services-kenya"
          element={<SEO />}
        />


        <Route
          path="/digital-strategy-consultation"
          element={<DigitalStrategyConsultation />}
        />


        <Route
          path="/custom-software-solutions"
          element={<CustomSoftwareSolutions />}
        />


        {/* =====================================
            404 ROUTE
            MUST BE LAST
        ===================================== */}

        <Route
          path="*"
          element={<NotFound />}
        />


      </Routes>


      {/* =====================================
          FOOTER
          HIDDEN ON CONTACT PAGE
      ===================================== */}

      {!isContactPage && <Footer />}

    </>

  );

};


export default App;